import $ from 'jquery';
import { TableViewUI } from './submodules/tableview/tableviewUI';
import { Tableview } from './submodules/tableview/tableview';
import { Modification } from './submodules/modification/modification';
import { ModificationUI } from './submodules/modification/modificationUI';
import { BF4MapcycleUI } from './submodules/bf4-mapcycle/BF4MapcycleUI';
import { BF4Mapcycle } from './submodules/bf4-mapcycle/BF4Mapcycle';
import { SquadMapcycleUI } from './submodules/squad-mapcycle/SquadMapcycleUI';
import { SquadMapcycle } from './submodules/squad-mapcycle/SquadMapcycle';
import { Preset } from './submodules/preset/preset';
import MultipleStringsUI from './submodules/multiple_strings/MultipleStringsUI';
import MultipleStrings from './submodules/multiple_strings/MultipleStrings';
import { Confirm } from '../../../confirm/confirm';
import { AvorionGalaxy } from './submodules/avorionGalaxy/avorionGalaxy';
import { World } from './submodules/world/world';
import Utils from '../../../utils/utils';
import { PresetSettings } from './submodules/presetSettings/presetSettings';
import { Dialog } from '../../../dialog/dialog';
import i18next from 'i18next';
import { Checkbox } from '../../../components/checkbox/checkbox';
import { MinecraftCustomSettingsUI } from './submodules/minecraft/minecraftCustomSettingsUI';
import { MinecraftCustomSettings } from './submodules/minecraft/minecraftCustomSettings';
import Axios from 'axios';
import { ValheimCustomSettingsUI } from './submodules/valheim/valheimCustomSettingsUI';
import { ValheimCustomSettings } from './submodules/valheim/valheimCustomSettings';

const sectionTemplate = require('./view/section.handlebars');

const BASE_SELECTOR = '[data-configuration]';
const SEARCH_SELECTOR = '[data-search]';
const SEARCH_ITEM_SELECTOR = '[data-search-value]';
const FORM_SELECTOR = '[data-configuration-form]';
const SAVE_BUTTON_SELECTOR = '[data-save]';
const DELETE_SAVEGAME_SELECTOR = '[data-delete-savegames]';
const DELETE_CHARACTER_SELECTOR = '[data-delete-characters]';
const RESET_SERVER_SETTINGS_TO_DEFAULT = '[data-reset-server-settings-default]';
const TABLEVIEW_SELECTOR = '[data-tableview]';
const MODIFICATION_SELECTOR = '[data-modification]';
const VALHEIM_MOD_SELECTOR = '[data-name="valheim-mods"]';
const MAPCYCLE_SELECTOR = '[data-mapcycle]';
const MULTIPLE_STRINGS_SELECTOR = '[data-multiple-string]';
const BROADCAST_SELECTOR = '[data-broadcast]';
const SHOW_HIDE_SECTION_SELECTOR = '[data-activate-section]';
const MINECRAFT_LEVEL_TYPE_CUSTOM = '[data-search-value="level-type-custom"] div';
const GAME_WIKI_SELECTOR = '[data-game-wiki]';

export class ConfigurationUI {
  private hiddenElementsIfServerOnline: JQuery[] = [];

  private hiddenElementsIfServerOffline: JQuery[] = [];

  public constructor(private $base: JQuery) {
    if (window.configWhenRunning === 0) {
      this.hiddenElementsIfServerOnline.push($('.basic-settings'));
      this.hiddenElementsIfServerOffline.push($('[data-hide-if-offline]'));
    }

    this.showWikiLink();
  }

  public showWikiLink() {
    const gameKey = $(GAME_WIKI_SELECTOR).data('game-key');
    if (!gameKey) {
      return;
    }
    Axios.get(`${window.wikiApiBaseUrl}game-key/${gameKey}`).then((response) => {
      if ("link" in response.data) {
        $(GAME_WIKI_SELECTOR).parents('.wrapper').find('.page-title').first().attr('data-wiki-exists', 1);
        $(GAME_WIKI_SELECTOR).show();
        $(GAME_WIKI_SELECTOR).children('a').first().attr('href', response.data.link.replace(/(^.+?\/)([a-z]{2}\/)(.+)/, '$1$3'));
        $(GAME_WIKI_SELECTOR).find('span span').text(response.data.title.rendered);
      }
    })
  }

  public isConfigurationEnabled() {
    return this.$base.attr('data-configuration-enabled') === '';
  }

  public enableConfiguration() {
    this.$base.attr('data-configuration-enabled', '');
  }

  public disableConfiguration() {
    this.$base.removeAttr('data-configuration-enabled');
  }

  public hideElementsIfServerOnline() {
    this.hiddenElementsIfServerOnline.map((el) => {
      $(el).addClass('is-disabled');
    });

    this.hiddenElementsIfServerOffline.map((el) => {
      $(el).css('display', 'flex');
    });
  }

  public showElementsIfServerOnline() {
    this.hiddenElementsIfServerOnline.map((el) => {
      $(el).removeClass('is-disabled');
    });

    this.hiddenElementsIfServerOffline.map((el) => {
      $(el).css('display', 'none');
    });
  }

  public getServiceId() {
    return $('[data-service-id]').first().data('service-id');
  }

  public showSettings() {
    $('[data-configuration-loading]').hide();
    this.$base.show();
  }

  /**
   * Render
   * Render the handlebars template
   * @param data - data from API Call
   * @param afterRender - callback method
   */
  public render(data, afterRender: () => {}) {
    this.$base.html(sectionTemplate(data));
    afterRender();
  }

  /**
   * The user enter something in the searchfield
   * @param callback
   */
  public onSearchInput(callback: (val: string) => {}) {
    this.$base.find(SEARCH_SELECTOR).on('keyup', (e: any) => {
      const val = e.currentTarget.value;
      callback(val);
    });
  }

  public onScroll(callback: (scrolltop: number) => {}) {
    $(document).on('scroll', (e: any) => {
      callback($(window).scrollTop());
    });
  }

  public setSettingsBarSticky(set: boolean) {
    if (set) {
      this.$base.find('.settings-top-bar').addClass('is-sticky');
      $('body').addClass('settings-top-bar-is-sticky');
    } else {
      this.$base.find('.settings-top-bar').removeClass('is-sticky');
      $('body').removeClass('settings-top-bar-is-sticky');
    }
  }

  public initTableview(data: any, form: any) {
    // const data = new Array();
    const ui: TableViewUI[] = [];
    $(TABLEVIEW_SELECTOR).each((i, el) => {
      const $table = $(el);
      ui.push(new TableViewUI($(el), data.virtual[$table.data('tableview')], form.sections[$table.data('tableview')].variables));
    });

    ui.map((ui: TableViewUI) => new Tableview(ui, ui.data, form));
  }

  public initModification(data: any, form: any) {
    const ui: ModificationUI[] = [];
    $(MODIFICATION_SELECTOR).each((i, el) => {
      ui.push(new ModificationUI($(el), data));
    });

    ui.map((ui: ModificationUI) => new Modification(ui, ui.data, form));
  }

  public initMinecraftCustomSettings(data: any, form: any) {
    const ui: MinecraftCustomSettingsUI [] = [];
    $(MINECRAFT_LEVEL_TYPE_CUSTOM).each((i, el) => {
      ui.push(new MinecraftCustomSettingsUI($(el), data));
    });

    ui.map((ui: MinecraftCustomSettingsUI) => new MinecraftCustomSettings(ui, ui.data, form));
  }

  public initValheimMods() {
    $(BASE_SELECTOR).each((i, el) => {
      new ValheimCustomSettings(new ValheimCustomSettingsUI($(el)))
    });
  }

  public initMultipleStrings() {
    const elements = $(MULTIPLE_STRINGS_SELECTOR);
    const ui = [];
    elements.each((i, el) => {
      ui.push(new MultipleStringsUI($(el)));
    });

    return ui.map((ui: MultipleStringsUI) => new MultipleStrings(ui));
  }

  public initBF4Mapcycle(data: any, form: any) {
    const ui: BF4MapcycleUI[] = [];
    $(MAPCYCLE_SELECTOR).each((i, el) => {
      ui.push(new BF4MapcycleUI($(el)));
    });

    ui.map((ui) => new BF4Mapcycle(ui, data, form));
  }

  public initSquadMapcycle(levelsData: any, layersData: any, form: any) {
    const ui: SquadMapcycleUI[] = [];
    $(MAPCYCLE_SELECTOR).each((i, el) => {
      ui.push(new SquadMapcycleUI($(el)));
    });

    ui.map((ui) => new SquadMapcycle(ui, levelsData, layersData, form));
  }

  // Battlefield
  public initPreset(data, form, afterRender: () => void) {
    if (typeof form.extraData !== 'undefined') {
      new Preset(this.render.bind(this), form, data, this.updateValues.bind(this), afterRender);
    }
  }

  public initPresetSettings(data, form) {
    new PresetSettings(this.render.bind(this), form, data, this.updateValues.bind(this));
  }

  // Special handling for Avorion (one server.ini per galaxy, which is like a savegame)
  public initGalaxy(galaxyData: any) {
    new AvorionGalaxy(this.render.bind(this), galaxyData);
  }

  public initWorld(worldData: any) {
    new World(this.render.bind(this), worldData);
  }

  /**
   * Find divs with indexof value
   * @param value
   */
  public search(value: string) {
    this.$base.find(SEARCH_ITEM_SELECTOR).each((i, el) => {
      if (value == '') {
        $(el).show();
        $(el).attr('data-visible', 'true');
      } else {
        const searchAttrValue: string = $(el).data('search-value');
        if (searchAttrValue.toLowerCase().indexOf(value.toLowerCase()) < 0) {
          $(el).hide();
          $(el).removeAttr('data-visible');
        } else {
          $(el).show();
          $(el).attr('data-visible', 'true');
        }
      }
    });

    this.hidePanel();
  }

  /**
   * The settings panel have no visible content
   */
  private hidePanel() {
    $('.panel--settings').each((index, el) => {
      const counter = $(el).find('[data-visible]').length;
      if (counter < 1) {
        $(el).prev().addClass('is-empty');
        $(el).addClass('is-empty');
      } else {
        $(el).prev().removeClass('is-empty');
        $(el).removeClass('is-empty');
      }
    });
  }

  /**
   * The user clicked the save button
   * @param callback
   */
  public onSubmit(callback: () => {}) {
    $(FORM_SELECTOR).on('submit', () => callback());
    $(SAVE_BUTTON_SELECTOR).on('click', () => callback());
  }

  public disableSubmitButton() {
    $(SAVE_BUTTON_SELECTOR).attr('disabled', 'disabled');
  }

  private static AllowOnlyLettersNumbersSpace(e): boolean {
    const char = String.fromCharCode(e.which);
    return char.match(/^[a-zA-Z0-9 ]*$/) != null;
  }

  /**
   * Update the values. Because the values are fetching after rendering
   * @param data
   */
  public updateValues(data) {
    if (Utils.isEmpty(data, 'virtual') && Utils.isEmpty(data.virtual, 'broadcast')) {
      $(BROADCAST_SELECTOR).show();
    }

    if ($(SHOW_HIDE_SECTION_SELECTOR).length > 0) {
      $(SHOW_HIDE_SECTION_SELECTOR).each((key, element) => {
        const checkboxIndex: number = $(element).find('.fancy-checkbox input').data('index');
        const checkbox: Checkbox = window.findCheckboxByIndex(checkboxIndex);
        checkbox.ui.$base.on('checkboxActivated', function () {
          $(this).parents('.panel').find('.section-wrapper').show();
        });

        checkbox.ui.$base.on('checkboxDeactivated', function () {
          $(this).parents('.panel').find('.section-wrapper').hide();
        });

        checkbox.onChange = () => {
          if (checkbox.ui.active == true) {
            $(element).parents('.panel').find('.section-wrapper').show();
          } else {
            $(element).parents('.panel').find('.section-wrapper').hide();
          }
        };
      });
    }

    return new Promise((resolve) => {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const element = data[key];

          for (const settings in element) {
            if (element.hasOwnProperty(settings)) {
              const settingsElement = element[settings];
              const selector = `[name="config[${key}][${settings}]"]`;
              const eTypeText = $(selector).is('input[type=\'text\']');

              if ((settingsElement === '' || settingsElement === null || settingsElement.toString().match('^{(.*)}') != null)
                && eTypeText === false) {
                continue;
              }

              // special case
              // show the "delete all savegames" button
              if (settings == 'deleteAllSavegame' && key === 'virtual' && settingsElement == true) {
                $(DELETE_SAVEGAME_SELECTOR).show();
              }
              // show the "delete all character" button
              if (settings == 'deleteAllCharacter' && key === 'virtual' && settingsElement == true) {
                $(DELETE_CHARACTER_SELECTOR).show();
              }
              // show the "restore server settings to default" button
              if (settings == 'showResetServerSettigsToDefault'
                && key === 'virtual' && settingsElement == true) {
                $(RESET_SERVER_SETTINGS_TO_DEFAULT).show();
              }

              const inputSelector = $(selector);
              if (inputSelector.length > 1) {
                console.log(`WARNING: Duplicated settings found! - ${selector}`);
              }

              if (inputSelector.length === 0) {
                continue;
              }

              if (inputSelector.data('ascii') !== undefined) {
                inputSelector.on('keypress paste', (e) => ConfigurationUI.AllowOnlyLettersNumbersSpace(e));
              }

              if (inputSelector.is('select')) {
                inputSelector.find('option').each((index, element) => {
                  if ($(element).val() == settingsElement) {
                    $(element).prop('selected', true);
                    inputSelector.trigger('change');
                  }
                });
              } else if (inputSelector.is(':checkbox')) {
                const checkboxIndex = inputSelector.data('index');
                const checkbox: Checkbox = window.findCheckboxByIndex(checkboxIndex);

                if (checkbox !== null
                  && settingsElement.toString().toLowerCase() === checkbox.ui.$base.data('true').toString().toLowerCase()) {
                  checkbox.setActive();
                  checkbox.ui.$base.trigger('checkboxActivated');
                } else {
                  checkbox.setInactive();
                  checkbox.ui.$base.trigger('checkboxDeactivated');
                }
              } else {
                if (typeof inputSelector.prop('nodeName') !== 'undefined') {
                  if (inputSelector.prop('nodeName') === 'A') {
                    if (settingsElement === 'false') {
                      inputSelector.attr('disabled', 'disabled');
                    } else {
                      inputSelector.attr('href', settingsElement).removeClass('is-disabled');
                    }
                  } else if (inputSelector.prop('nodeName') === 'SPAN') {
                    if (inputSelector.find('.value').length > 0) {
                      inputSelector.find('.value').text(settingsElement);
                    }
                  }
                }

                if (settingsElement !== null) {
                  inputSelector.val(settingsElement.toString());
                }
                inputSelector.trigger('change');
              }
            }
          }
        }
      }
      resolve(true);
    });
  }

  /**
   * The user wants to delete his savesgames
   * @param callback
   */
  public onDeleteSavesgames(callback: () => {}) {
    $(DELETE_SAVEGAME_SELECTOR).on('click', (e) => {
      e.preventDefault();
      new Dialog()
        .withTitle(i18next.t('configuration:actions.delete_save_games.title'))
        .withText(i18next.t('configuration:actions.delete_save_games.text'))
        .withOnConfirm(() => callback())
        .withIcon('trash-alt')
        .withConfirmButtonText(i18next.t('general:non_special_texts.confirm'))
        .withCenteredContent()
        .render();
    });
  }

  /**
   * The user wants to delete his character
   * @param callback
   */
  public onDeleteCharcacters(callback: () => {}) {
    $(DELETE_CHARACTER_SELECTOR).on('click', (e) => {
      e.preventDefault();
      new Dialog()
        .withTitle('Are you sure?')
        .withText('Every character will be finally deleted, are you sure?')
        .withOnConfirm(() => callback())
        .withIcon('trash-alt')
        .withConfirmButtonText('Confirm')
        .withCenteredContent()
        .render();
    });
  }

  /**
     * The user wants to delete his character
     * @param callback
     */
  public onResetServerSettingsToDefault(callback: () => {}) {
    $(RESET_SERVER_SETTINGS_TO_DEFAULT).on('click', (e) => {
      e.preventDefault();
      new Dialog()
        .withTitle(i18next.t('configuration:actions.reset_server_settings_default.title'))
        .withText(i18next.t('configuration:actions.reset_server_settings_default.text'))
        .withOnConfirm(() => callback())
        .withIcon('cog')
        .withConfirmButtonText(i18next.t('general:non_special_texts.confirm'))
        .withCenteredContent()
        .render();
    });
  }

  /**
   * Decative/Activate deleteSavegameButton
   */
  public toggleDeleteSaveGameButton(state: boolean) {
    if (state) {
      $(DELETE_SAVEGAME_SELECTOR).removeAttr('disabled');
    } else {
      $(DELETE_SAVEGAME_SELECTOR).attr('disabled', 'disabled');
    }
  }

  /**
   * Decative/Activate deleteCharacterButton
   */
  public toggleDeleteCharacterButton(state: boolean) {
    if (state) {
      $(DELETE_CHARACTER_SELECTOR).removeAttr('disabled');
    } else {
      $(DELETE_CHARACTER_SELECTOR).attr('disabled', 'disabled');
    }
  }

  /**
     * Decative/Activate deleteCharacterButton
     */
  public toggleResetServerSettingsToDefault(state: boolean) {
    if (state) {
      $(RESET_SERVER_SETTINGS_TO_DEFAULT).removeAttr('disabled');
    } else {
      $(RESET_SERVER_SETTINGS_TO_DEFAULT).attr('disabled', 'disabled');
    }
  }
}

export function createConfigurationUI(): ConfigurationUI[] {
  const $base = $(BASE_SELECTOR);
  const instances: ConfigurationUI[] = [];

  $base.map((index, el) => {
    instances.push(new ConfigurationUI($(el)));
  });

  return instances;
}
